<template>
	<div class="view-wrapper">
		<div 	class="view-container"
				v-if="user !== null && error == null">
			<b-container class="no-padding">
				<b-row>
					<b-col 	md="4"
							sm="12"
							class="text-center">
						<span class="icon-user icon-large"></span>
						<div class="space30"></div>							
					</b-col>
					<b-col 	md="8"
							sm="12">
						<p><h3 class="vrnu-headline">{{ user.firstname }} {{ user.lastname }}</h3></p>
						<b-container class="no-padding">
							<b-row>
								<b-col 	lg="6"
										md="12">
									<h4 class="text-underlined">Zugangsdaten</h4>
									<span>{{ user.email }}</span>
									<div class="space30"></div>							
								</b-col>
								<b-col 	lg="6"
										md="12">
									<h4 class="text-underlined">Aktiv</h4>
									<span v-if="user.active">
										<span class="icon-check text-green"></span> Der Benutzer ist aktiv und darf sich einloggen
									</span>
									<span v-else>
										<span class="icon-cancel text-red"></span> Der Benutzer ist nicht aktiv und darf sich nicht einloggen
									</span>
									<div class="space30"></div>
								</b-col>
							</b-row>
						</b-container>
					</b-col>
				</b-row>
			</b-container>
		</div>
		<div v-else>
			<b-alert show variant="danger">{{ error }}</b-alert>
		</div>
	</div>
</template>

<script>
export default {
	data: function() {
		return {
			user: null,
			error: null,
		};
	},
	methods: {
		getUser: function() {
			// Save the user
			this.$http.get('users/' + this.objectId).then(result => {
				this.user = result.body;
			}, response => {
				this.error = "Beim Laden des Benutzers ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		closeModal: function() {
			this.$emit('closeModal');
		},
	},
	mounted: function() {
		// Load user from database
		this.getUser();
	},
	props: {
		objectId: {
			required: true,
		}
	},
}
</script>

<style>
.form-container {
	padding: 5px;
}
.text-underlined {
	text-decoration: underline;
}
.icon-large {
	font-size: 8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/07_user/UsersView.vue